import {Vue, Component, Inject, Watch} from 'vue-property-decorator';
import { required, email, minLength, numeric } from 'vuelidate/lib/validators';
var creditCardType = require("credit-card-type");
import CreditCardMapping from '@/config/credit-card-mapping';
import RegistrationService from "@/apis/registration";
import LocationService from "@/apis/location";
import md5 from 'crypto-js/md5';
import * as paymentApi from "@/apis/payment";
import * as codeBy from "@/methods/getCodeByState";

const validations = {
	primaryPhoneNumber: { required, minLength: minLength(14) },
	secondPhoneNumber: { minLength: minLength(14) },
	email: { required, email },
	fullName: { required },
}

@Component({
	validations
})
export default class editProfileComponents extends Vue {
	@Inject('registrationService') private registrationService!: () => RegistrationService;
	@Inject('locationService') private locationService!: () => LocationService;

	isPromotions = false;

	isBusiness = false;

	maskCard = "#### #### #### ###X";

	maskPhone = "### ### ###X";

	maskDate = "##/##";

	numberCard = '';

	businessPhone = '';

	isBusinessFirst = '';

	cartExpirationDate = '';

	public monthMask = function(value: any) {
		return ([/[0-1]/, value.charAt(0) === '1' ? /[1-2]/ : /[0-9]/, '/' , /[0-9]/,/[0-9]/]);
	};

	public fullName = '';
	public persistentFullName = '';
	public primaryPhoneNumber = '';
	public secondPhoneNumber = '';
	public email = '';
	public login = '';

	public cardFullName: string = '';
	public cardFirstName: string = '';
	public cardLastName: string = '';

	public address = '';
	public unit = '';
	public city = '';
	public postalCode = '';
	public location: {} = {};

	public password = '';
	public passwordToSet = '';
	public confirmationPassword = '';
	public wrongCredentials = false;
	public succeed = false;
	public errMsg = '';
	public errorPass = '';
	public firstName = '';
	public lastName = '';
	public valid = true;

	public typeCard = '';
	public cardNumberFromServer = '';
	public cardImage = '';
	public cardId = '';
	public merchantCustomerId = '';

	authNetCard = '';
	authNetClient = '';

	public errorUser = '';
	public errorLocation = '';

	@Watch('cardFullName')
	watchCardFullName() {
		if(this.cardFullName){
			var fullName = this.cardFullName.split(' ')
			this.cardFirstName = fullName[0]
			this.cardLastName = fullName[fullName.length - 1];
		}
	}

	async mounted() {
		await this.loadCreditCards();
		const isLocationExistRequest = {
			"securityToken": this.$store.getters.token,
			"sortDirection": "0",
			"clientID": this.$store.getters.clientId,
			"pageSize": "50",
			"sortMode": "1",
			"pageNo": "1",
			"isCompleteObject": "true"
		}
		this.$store.commit('setOverlay', true)
		const contact = await this.registrationService().getAContactsDetails();
		if ('errNo' in contact && contact.errNo !== 0) {
			let errMsg = 'errMsg' in contact ? contact.errMsg : 'Service is unavailable';
			if (contact.Errors && contact.Errors.length) {
				const [firstError] = contact.Errors;
				({ errMsg } = firstError);
			}
			this.$store.commit('setOverlay', false)
			this.errorUser = errMsg
			throw new Error(errMsg);
		}
		const client = await this.registrationService().getAClientsDetails();
		if ('errNo' in client && client.errNo !== 0) {
			let errMsg = 'errMsg' in client ? client.errMsg : 'Service is unavailable';
			if (client.Errors && client.Errors.length) {
				const [firstError] = client.Errors;
				({ errMsg } = firstError);
			}
			this.$store.commit('setOverlay', false)
			this.errorUser = errMsg
			throw new Error(errMsg);
		}
		this.location = await this.locationService().getLocationByClient(isLocationExistRequest);
		//@ts-ignore
		if ('errNo' in this.location && this.location.errNo !== 0) {
			//@ts-ignore
			let errMsg = 'errMsg' in this.location ? this.location.errMsg : 'Service is unavailable';
			//@ts-ignore
			if (this.location.Errors && this.location.Errors.length) {
				//@ts-ignore
				const [firstError] = this.location.Errors;
				({ errMsg } = firstError);
			}
			this.$store.commit('setOverlay', false)
			this.errorUser = errMsg
			throw new Error(errMsg);
		}
		this.$store.commit('setOverlay', false)
		// @ts-ignore
		contact.Fields.forEach(field => {
			if (field.fieldID === 9795) {
				this.persistentFullName = field.fieldValue;
				this.fullName = field.fieldValue;
			}
			if (field.fieldID === 6184) this.login = field.fieldValue;
			if (field.fieldID === 1088) this.primaryPhoneNumber = field.fieldValue;

			if (field.fieldID === 97) this.email = field.fieldValue;
			if (field.fieldID === 96) this.secondPhoneNumber = field.fieldValue;
		})
		this.primaryPhoneNumber = `(${this.primaryPhoneNumber.substring(0,3)}) ${this.primaryPhoneNumber.substring(3,6)}-${this.primaryPhoneNumber.substring(6, 11)}`
		this.secondPhoneNumber = `(${this.secondPhoneNumber.substring(0,3)}) ${this.secondPhoneNumber.substring(3,6)}-${this.secondPhoneNumber.substring(6, 11)}`
		// @ts-ignore
		client.Fields.forEach(field => {
			if (field.fieldID === 121) {
				// @ts-ignore
				this.isBusiness = (field.optionID === 60);
				// @ts-ignore
				this.isBusinessFirst = (field.optionID === 60);
			}
			if (field.fieldID === 9058) {
				this.isPromotions = field.fieldValue === 'true';
			}
		})
		// @ts-ignore
		if (this.location.Locations[0]) {
			// @ts-ignore
			this.location.Locations[0].Fields.forEach(field => {
				if (field.fieldID === 776) this.city = field.fieldValue;
				if (field.fieldID === 773) this.address = field.fieldValue;
				if (field.fieldID === 775) this.postalCode = field.fieldValue;
				if (field.fieldID === 9714) this.unit = field.fieldValue;
			})
		}
	}

	public async loadCreditCards(){
		const requestData = {
			securityToken: this.$store.getters.token,
			clientId: this.$store.getters.clientId,
		};
		const loadCreditCards= await paymentApi.getCreditCards(requestData)
		const { data } = loadCreditCards;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			throw new Error(errMsg);
		} else {
			if(data.Cards && data.Cards.length !== 0) {
				this.authNetCard = data.Cards[0].authNetCard
				this.authNetClient = data.Cards[0].authNetClient
				this.cardId = data.Cards[0].cardID
				this.getProfileAuthorize()
				const [cardType, cardNumber] = data.Cards[0].card
					.replace('**** **** ****', '')
					.replace('  ', ' ')
					.split(' ');
				this.cardNumberFromServer = cardNumber
				this.typeCard = data.Cards[0].card.match(/\((.*)\)/).pop();
				const cardTypeShortName = this.typeCard;
				let cartInfoKey = null;
				if (cardTypeShortName) {
					cartInfoKey = Object.keys(CreditCardMapping).find(
						// @ts-ignore
						(key) => key === cardTypeShortName,
					);
					// @ts-ignore
					this.cardImage = cartInfoKey ? CreditCardMapping[cartInfoKey].img : '';
				}
			}
		}
	}

	public async getProfileAuthorize() {
		const requestDataForAuthorize = {
			customerProfileId: this.authNetClient,
		};

		const authorizeResponse = await paymentApi.getCustomerProfileAuthorize(requestDataForAuthorize)
		if(authorizeResponse.messages.resultCode === 'Error' && authorizeResponse.messages.resultCode){
			this.errorUser = 'Error authorizeResponse'
			throw new Error('Error authorizeResponse');
		}
		else {
			this.merchantCustomerId = authorizeResponse.profile.merchantCustomerId
		}
	}

	public async updatePayProfileAuthorize() {
		//@ts-ignore
		this.numberCard = this.numberCard.replace(/\s+/g, '');
		const requestDataForAuthorize = {
			customerPaymentProfileId: this.authNetCard,
			customerProfileId: this.authNetClient,
			firstName: this.cardFirstName,
			lastName: this.cardLastName,
			address: this.address,
			city: this.city,
			state: this.unit,
			postalCode: this.postalCode,
			phone: this.primaryPhoneNumber.replace(/[\s\-\(\)]+/g , ''),
			cardNumber: this.numberCard,
			// cardCode: Number(this.cvv),
			expirationDate: this.cartExpirationDate,
		};

		const authorizeResponse = await paymentApi.updateCustomerPayProfileAuthorize(requestDataForAuthorize)
		if(authorizeResponse.messages.resultCode === 'Error' && authorizeResponse.messages.resultCode){
			this.errorUser = 'Error authorizeResponse'
			throw new Error('Error authorizeResponse');
		}
	}

	public async updateProfileAuthorize() {
		const requestDataForAuthorize = {
			merchantCustomerId: this.merchantCustomerId,
			email: this.email,
			customerProfileId: this.authNetClient,

		};
		const authorizeResponse = await paymentApi.updateCustomerProfileAuthorize(requestDataForAuthorize)
		if(authorizeResponse.messages.resultCode === 'Error' && authorizeResponse.messages.resultCode){
			this.errorUser = 'Error authorizeResponse'
			throw new Error('Error authorizeResponse');
		}
	}

	public async updateCardOnServer(customerProfileId?:any,paymentProfileId?:any) {
		const requestDataForSavingCard = {
			securityToken: this.$store.getters.token,
			clientId: this.$store.getters.clientId,
			firstName: this.cardFirstName,
			lastName: this.cardLastName,
			address: this.address,
			city: this.city,
			cardID: this.cardId,
			method: 14,
			state: this.unit,
			postalCode: this.postalCode,
			authNetClient: customerProfileId  ? customerProfileId : this.authNetClient,
			authNetCard: paymentProfileId  ? paymentProfileId : this.authNetCard,
			last4Digits: this.last4DigitsForServer,
		};
		const saveCreditCardRes = await paymentApi.saveCreditCard(requestDataForSavingCard)
		const { data } = saveCreditCardRes;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			this.$store.commit('setOverlay', false)
			this.errMsg = errMsg
			throw new Error(errMsg);
		}
	}

	public async updateCreditCard() {
		//@ts-ignore
		if (this.$refs.formCard.validate()) {
			if (this.authNetCard && this.authNetClient && this.cardId) {
				await this.updateProfileAuthorize()
				await this.updatePayProfileAuthorize()
				await this.updateCardOnServer()
			}
			else {
				await this.createProfileAuthorize()
			}
			//@ts-ignore
			// this.$refs.formCard.reset()
			// this.cartExpirationDate = ''
			this.loadCreditCards()
		}
	}

	public async createProfileAuthorize() {
		//@ts-ignore
		this.numberCard = this.numberCard.replace(/\s+/g, '');
		const requestDataForAuthorize = {
			clientId: this.$store.getters.clientId,
			email: this.email,
			firstName: this.cardFirstName,
			lastName: this.cardLastName,
			address: this.address,
			city: this.city,
			state: this.unit,
			postalCode: this.postalCode,
			phone: this.primaryPhoneNumber.replace(/[\s\-\(\)]+/g , ''),
			cardNumber: this.numberCard,
			// cardCode: Number(this.cvv),
			expirationDate: this.cartExpirationDate,
		};

		const authorizeResponse = await paymentApi.createCustomerProfileAuthorize(requestDataForAuthorize)
		const { customerProfileId } = authorizeResponse;
		if (!customerProfileId
			|| !authorizeResponse.customerPaymentProfileIdList
			|| !authorizeResponse.customerPaymentProfileIdList.length) {
			throw new Error('AuthorizeNetAddingCard');
		}
		const paymentProfileId = authorizeResponse.customerPaymentProfileIdList[0];

		this.updateCardOnServer(customerProfileId,paymentProfileId)
	}

	get last4DigitsForServer() {
		const cardNumber = this.numberCard ? this.numberCard.toString().substr(- 4) : '';
		const cardType = creditCardType(this.numberCard.toString())[0].type;
		return `${cardType}:${cardNumber}`;
	}

	public async updateProfileInfo() {
		this.errorUser = '';
		const clientRequest = {
			"securityToken": this.$store.getters.token,
			"method": 2,
			"objectID": this.$store.getters.clientId,
			"Fields": [
				{
					"fieldID": 9058,
					"fieldValue": this.isPromotions
				},
				{
					"fieldID": 1091,
					"fieldValue": this.email
				},
				{
					"fieldID": 126,
					"fieldValue": this.fullName
				},
				{
					"fieldID": 129,
					"fieldValue": this.address
				},
				{
					"fieldID": 112,
					"fieldValue": this.primaryPhoneNumber.replace(/[\s\-\(\)]+/g , '')//phoneNumber
				},
				{
					"fieldID": 121,
					"optionID": this.isBusiness ? 60 : 59
				}
			]
		}
		this.$store.commit('setOverlay', true)
		let clientResponse = await this.registrationService().updateAClient(clientRequest);
		if ('errNo' in clientResponse && clientResponse.errNo !== 0) {
			let errMsg = 'errMsg' in clientResponse ? clientResponse.errMsg : 'Service is unavailable';
			if (clientResponse.Errors && clientResponse.Errors.length) {
				const [firstError] = clientResponse.Errors;
				({ errMsg } = firstError);
			}
			this.errorUser = errMsg
			throw new Error(errMsg);
		}
		// if (clientResponse.Client){
		// 	const clientId = clientResponse.Client.objectID
		// 	this.$store.commit('updateClientId', clientId)
		// }


		const contactRequest = {
			"securityToken": this.$store.getters.token,
			"method": "2",
			"objectID": this.$store.getters.contactId,
			"Fields":
				[
					{
						"fieldID": 97,//email
						"fieldValue": this.email
					},
					{
						fieldID: 127,
						fieldValue: this.firstName ? this.firstName : '',
					},
					{
						fieldID: 128,
						fieldValue: this.lastName ? this.lastName : '',
					},
					{
						fieldID: 9795,
						fieldValue: this.fullName,
					},
					{
						"fieldID": 96,//mobile phone
						"fieldValue": this.secondPhoneNumber.replace(/[\s\-\(\)]+/g , '')
					},
					{
						"fieldID": 1088,//mobile phone
						"fieldValue": this.primaryPhoneNumber.replace(/[\s\-\(\)]+/g , '')
					}
				]
		}
		let contactResponse = await this.registrationService().updateAContact(contactRequest);
		if ('errNo' in contactResponse && contactResponse.errNo !== 0) {
			let errMsg = 'errMsg' in contactResponse ? contactResponse.errMsg : 'Service is unavailable';
			if (contactResponse.Errors && contactResponse.Errors.length) {
				const [firstError] = contactResponse.Errors;
				({ errMsg } = firstError);
			}
			this.$store.commit('setOverlay', false)
			this.errorUser = errMsg
			throw new Error(errMsg);
		}
		this.$store.commit('setOverlay', false)
	}

	@Watch('fullName')
	watchFullName() {
		var fullName = this.fullName.split(' ')
		this.firstName = fullName[0]
			this.lastName = fullName[1];

	}

	public async updateLocationInformation() {
		const state = await codeBy.getStateCodeByTitle(this.unit)
		this.$store.commit('setOverlay', true)
		this.errorLocation = ''
		const fields = [
			{
				"fieldID": 779,//Country
				"optionID": "9907" //canada
			},
			{
				"fieldID": 778,//Location Province
				"optionID": state
			},
			{
				"fieldID": 776,//Location City
				"fieldValue": this.city
			},
			{
				"fieldID": 773,//Location Street
				"fieldValue": this.address
			},
			{
				"fieldID": 775,//Location Zip Code
				"fieldValue": this.postalCode//m6b1t5 for tests
			},
			{
				"fieldID": 774,//Location Zip+4
				"fieldValue": ""
			},
			{
				"fieldID": 9714,//Location Title
				"fieldValue": this.unit
			},
			{
				"fieldID": 9713,//Location Directions
				"fieldValue": "Some Directions"
			}
		]
		// @ts-ignore
		if (this.location.Locations.length === 0) {
			const addLocationData = {
				"securityToken": this.$store.getters.token,
				"method": "3",
				"clientID": this.$store.getters.clientId,
				"Fields": fields
			}
			const locationResponse = await this.locationService().addLocation(addLocationData);
			if ('errNo' in locationResponse && locationResponse.errNo !== 0) {
				let errMsg = 'errMsg' in locationResponse ? locationResponse.errMsg : 'Service is unavailable';
				if (locationResponse.Errors && locationResponse.Errors.length) {
					const [firstError] = locationResponse.Errors;
					({ errMsg } = firstError);
				}
				this.$store.commit('setOverlay', false)
				this.errorLocation = errMsg
				throw new Error(errMsg);
			}
			this.$store.commit('setOverlay', false)
		} else {
			// @ts-ignore
			const locationId = this.location.Locations[0].objectID;
			const editLocationData = {
				"securityToken": this.$store.getters.token,
				"method": "2",
				"objectID": locationId,
				"Fields": fields
			}
			const locationResponse = await this.locationService().addLocation(editLocationData);
			if ('errNo' in locationResponse && locationResponse.errNo !== 0) {
				let errMsg = 'errMsg' in locationResponse ? locationResponse.errMsg : 'Service is unavailable';
				if (locationResponse.Errors && locationResponse.Errors.length) {
					const [firstError] = locationResponse.Errors;
					({ errMsg } = firstError);
				}
				this.$store.commit('setOverlay', false)
				this.errorLocation = errMsg
				throw new Error(errMsg);
			}
			this.$store.commit('setOverlay', false)
		}
	}

	public async setNewPassword() {
		this.errorPass = ''
		this.$store.commit('setOverlay', true)
		const response = await this.validateOldPassword();
		if (response.errMsg) {
			this.succeed = false;
			this.wrongCredentials = true;
			this.errMsg = response.errMsg;
			this.$store.commit('setOverlay', false)
		} else {
			this.wrongCredentials = false
			const newPasswordRequest = {
				"securityToken": this.$store.getters.token,
				"method": "8",
				"objectID": this.$store.getters.contactId,
				"clientID": this.$store.getters.clientId,
				"userName": this.login,
				"password": (md5(this.passwordToSet)).toString()
			}
			const newPasswordResponse = await this.registrationService().setContactsSignInCredentials(newPasswordRequest);
			if ('errNo' in newPasswordResponse && newPasswordResponse.errNo !== 0) {
				let errMsg = 'errMsg' in newPasswordResponse ? newPasswordResponse.errMsg : 'Service is unavailable';
				if (newPasswordResponse.Errors && newPasswordResponse.Errors.length) {
					const [firstError] = newPasswordResponse.Errors;
					({ errMsg } = firstError);
				}
				this.$store.commit('setOverlay', false)
				this.errorPass = errMsg
				throw new Error(errMsg);
			}

			if (newPasswordResponse) {
				this.succeed = true;
				this.errMsg = '';
			}
			this.$store.commit('setOverlay', false)
		}
	}

	get isPasswordsMatch() {
		return this.passwordToSet === this.confirmationPassword;
	}

	public async validateOldPassword() {
		const authData = {
			"securityToken": this.$store.getters.token,
			"method": "7",
			"userName": this.login,
			"password": (md5(this.password)).toString()
		}

		const auth = (await this.registrationService().authenticateContactForSelfSignIn(authData));
		return auth;
	}
}
